<template>
  <div class="avatarImage-box">
    <img v-if="avatarUrl" class="avatarImage" :src="avatarUrl" />
    <div v-else-if="name" class="avatarImage">{{name?.substr(0,1)}}</div>
  </div>
</template>

<script>
import { ref, reactive, onBeforeMount } from 'vue'
import router from '@/router'
import { getUrlQuery, isUrl } from '@/utils/url.js'
import { fileApi } from '@/apis'

export default {
  props: {
    avatarUrl: String,
    name: String,
  },
  setup(props, { emit }) {
    return {}
  },
}
</script>

<style lang="scss">
.avatarImage-box {
  .avatarImage {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    border-radius: 50%;
    width: 54px;
    height: 54px;
    font-size: 28px;
    color: #fff;
    background-color: #e6a23c;
    background-color: #e6a23c;
  }
}
</style>